const store = WPTB.store.store;

export default store;
export type AppDispatch = typeof store.dispatch;

export const {
    addNotification,
    setNotificationItems,
    updateNotification,
    clearNotification,
    setUpsell,
    setTable,
    changeId,
    startBuilder,
    setTableInfo,
    setResponsive,
    addBlock,
    removeBlock,
    duplicateBlock,
    moveBlockInto,
    mergeCells,
    splitCell,
    removeCol,
    removeRow,
    addColumn,
    addRow,
    sortRows,
    sortColumns,
    customReducer,
    setSettings,
    setActiveBlock,
    timeTravel,
    timeTravelAdded,
    startSaving,
} =  WPTB.store.actions;